export default "__VITE_ASSET__Dt8xWdos__"